import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("ef_token");
    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
});

api.interceptors.response.use(
    (r) => r,
    (err) => {
        if (err?.response?.status === 401) {
            // let caller handle
        }
        return Promise.reject(err);
    }
);

export const PILLAR_COLORS = {
    nutrition: { hex: "#2DD4BF", bg: "bg-teal-400", text: "text-teal-500", soft: "bg-teal-50", border: "border-teal-200" },
    exercise: { hex: "#F87171", bg: "bg-red-400", text: "text-red-500", soft: "bg-red-50", border: "border-red-200" },
    sleep: { hex: "#60A5FA", bg: "bg-blue-400", text: "text-blue-500", soft: "bg-blue-50", border: "border-blue-200" },
    stress: { hex: "#22D3EE", bg: "bg-cyan-400", text: "text-cyan-500", soft: "bg-cyan-50", border: "border-cyan-200" },
};

// Self-hosted optimised logos (~5–27 KB instead of 307 KB at 1000×1000).
// Original Emergent-asset URLs are kept commented in case we ever need to
// regenerate from source. Note: LOGO_DARK is the light-coloured variant used
// over dark backgrounds (footer); LOGO_LIGHT is the full-colour version used
// over light backgrounds.
export const LOGO_DARK = "/logo-dark-192.png";   // transparent-on-dark variant for footer / dark surfaces
export const LOGO_LIGHT = "/logo-192.png";       // full-colour variant for nav / light surfaces

// Friendly extractor for FastAPI error responses, including structured 429 quota errors.
export function formatApiError(err, fallback = "Something went wrong") {
    const detail = err?.response?.data?.detail;
    if (!detail) return fallback;
    if (typeof detail === "string") return detail;
    if (typeof detail === "object" && detail.message) return detail.message;
    return fallback;
}

export function isQuotaError(err) {
    return err?.response?.status === 429 && typeof err?.response?.data?.detail === "object";
}

